import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Always attach Bearer token if present (cross-site cookies sometimes blocked)
api.interceptors.request.use((cfg) => {
    const token = localStorage.getItem("gtw_token");
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
    return cfg;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            localStorage.removeItem("gtw_token");
        }
        return Promise.reject(err);
    },
);

export function formatError(err, fallback = "Something went wrong") {
    const d = err?.response?.data?.detail;
    if (!d) return err?.message || fallback;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(", ");
    if (d?.message) return d.message;
    if (d?.msg) return d.msg;
    return JSON.stringify(d);
}

export default api;
